import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-ivsitee',
  templateUrl: './ivsitee.component.html',
  styleUrls: ['./ivsitee.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class IvsiteeComponent implements OnInit {
  columnsToDisplay = ['Name', 'Description', 'IsActive'];
  headercolumnsToDisplay = ['IVSite', 'Description', 'Is Active'];
  public show: boolean = false;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  ivsiteeform: FormGroup;
  submitted = false;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.ivsiteeform = this.formBuilder.group({

      name: ['',],
      isactive: ['',],
      description: ['',],
      names: ['',],
      isactivee: ['',],
      descriptionn: ['',]

    });

  }

  get f() { return this.ivsiteeform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.ivsiteeform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.ivsiteeform.value))
  }
}





